var render = function render(){var _vm=this,_c=_vm._self._c;return _c('view-rent-notes',{ref:"viewRentNotes",attrs:{"show-resolve":_vm.showResolve,"add-note":_vm.addNote,"is-bulk":""},on:{"closeNotes":function($event){return _vm.notesClosed($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }